import axios from 'axios'
import store from '../store'
import i18n from './i18n'
import helper from './helper'
import router from '../router'

const axiosInstance = axios.create({
  baseURL: process.env.ROOT_HOST_PORT_API,
  timeout: 30000
})

axiosInstance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status) {
    if (error.response.status === 502) {
      router.push({ name: 'Wartung', params: { maintenance: true } })
    }
  }
  return Promise.reject(error)
})

const debugLog = function () {
  // console.log(arguments)
}

const getAdditionalHeader = function (options) {
  let httpOptions = {}
  const jwToken = localStorage.getItem('VBus.net-JWT')
  const lang = store.state.lng

  if (jwToken) {
    httpOptions = {
      headers: {
        Authorization: jwToken,
        'Accept-Language': lang,
        'X-Powered-By': 'RESOL VBus.net Team',
        'Server': 'VBus.net web server 1.3.3.7'
      }
    }
  } else {
    httpOptions = {
      headers: {
        'Accept-Language': lang,
        'X-Powered-By': 'RESOL VBus.net Team',
        'Server': 'VBus.net web server 1.3.3.7'
      }
    }
  }

  return httpOptions
}

const http = {
  get (url, options) {
    const httpOptions = getAdditionalHeader(options)
    debugLog('httpOptions', httpOptions)
    return axiosInstance.get(url, httpOptions).then(response => {
      debugLog('http get', response)
      return response
    }).catch((error) => {
      debugLog('http get error', error)
      if (error.response) {
        return error.response
      } else if (error.request) {
        return error.request
      } else {
        return error.message
      }
    })
  },

  post (url, data, options) {
    const httpOptions = getAdditionalHeader(options)
    debugLog('http post >', httpOptions)
    return axiosInstance.post(url, data, httpOptions).then(response => {
      debugLog('http post >', response)
      return response
    }).catch((error) => {
      debugLog('http post error', error)
      if (error.response) {
        return error.response
      } else if (error.request) {
        return error.request
      } else {
        return error.message
      }
    })
  },

  put (url, data, options) {
    const httpOptions = getAdditionalHeader(options)
    return axiosInstance.put(url, data, httpOptions).then(response => {
      debugLog('http put', response)
      return response
    }).catch((error) => {
      debugLog('http put error', error)
      if (error.response) {
        return error.response
      } else if (error.request) {
        return error.request
      } else {
        return error.message
      }
    })
  },

  delete (url, options) {
    const httpOptions = getAdditionalHeader(options)
    return axiosInstance.delete(url, httpOptions).then(response => {
      debugLog('http delete', response)
      return response
    }).catch((error) => {
      debugLog('http delete error', error)
      if (error.response) {
        return error.response
      } else if (error.request) {
        return error.request
      } else {
        return error.message
      }
    })
  },

  readConfiguration () {
    return this.get('configurations').then(response => {
      return (response && response.data) ? response.data : {}
    }).catch(ex => {
      console.log('Error: read current session', ex)
    })
  },

  readSession () {
    return this.get('session/current').then(response => {
      if (response.data && response.data.id) {
        store.commit('setAuthorization', true)
        store.commit('setUser', response.data)

        const settings = response.data.settings
        if (settings) {
          // todo login
          let lng = 'de'
          if (window.localStorage) {
            const languages = ['de', 'en', 'fr', 'es', 'it']
            const lsLng = localStorage.getItem('lng')
            if (lsLng && languages.indexOf(lsLng) > -1) {
              lng = lsLng
              i18n.i18next.changeLanguage(lng)
            }
          }
          let defaultUnits = {}
          try {
            if (settings.default_units) {
              defaultUnits = JSON.parse(settings.default_units)
            }
          } catch (e) {
            console.log(e)
          }
          store.commit('setSettings', {
            sorting: true,
            filterOpen: false,
            devices: 'all',
            deviceType: 'all',
            keywords: [],
            dateFormat: helper.seperateDateTime(settings.date_format).date,
            timeFormat: helper.seperateDateTime(settings.date_format).time,
            dateTimeFormat: settings.date_format ? settings.date_format : 'DD.MM.YYYY HH:mm:ss',
            menutype: settings.short_menu,
            Language: response.data.email_language || 'de',
            Power: defaultUnits.Power ? defaultUnits.Power : 'Watts',
            Pressure: defaultUnits.Pressure ? defaultUnits.Pressure : 'Bars',
            Temperature: defaultUnits.Temperature ? defaultUnits.Temperature : 'DegreesCelsius',
            Volume: defaultUnits.VolumeFlow ? defaultUnits.VolumeFlow : 'LitersPerHour',
            Energy: defaultUnits.Energy ? defaultUnits.Energy : 'WattHours',
            startPage: settings.start_page ? settings.start_page : null
          })
        }
        return true
      }
    }).catch(ex => {
      console.log('Error: read current session', ex)
    }).then(() => {
      return false
    })
  },

  install (Vue) {
    Vue.prototype.$http = {
      get: this.get,
      post: this.post,
      put: this.put,
      delete: this.delete,
      readSession: this.readSession,
      readConfiguration: this.readConfiguration
    }
  }
}

export default http



// WEBPACK FOOTER //
// ./src/plugins/http.js